import moment from 'moment'

export const formatDate = (date) =>
    moment(date, 'YYYYMMDD').format('MM/DD/YYYY')
